// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  display: flex;
  justify-content: center;
  vertical-align: middle;
  height: 100vh;
  align-items: center;
  background: var(--themeColor);
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #000;
  margin: -4px 0 0 -4px;
}

.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}

.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}

.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}

.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}

.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}

.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}

.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}

.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}

.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}

.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}

.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}

.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}

.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}

.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}

.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}

.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
}

.loader {
  position: absolute;
  padding: 0.75rem;
  border-width: 1px;
  border-color: #9ca3af;
  width: 25%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/loader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".loader-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  vertical-align: middle;\r\n  height: 100vh;\r\n  align-items: center;\r\n  background: var(--themeColor);\r\n}\r\n.lds-roller {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n.lds-roller div {\r\n  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\r\n  transform-origin: 40px 40px;\r\n}\r\n\r\n.lds-roller div:after {\r\n  content: \" \";\r\n  display: block;\r\n  position: absolute;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #000;\r\n  margin: -4px 0 0 -4px;\r\n}\r\n\r\n.lds-roller div:nth-child(1) {\r\n  animation-delay: -0.036s;\r\n}\r\n\r\n.lds-roller div:nth-child(1):after {\r\n  top: 63px;\r\n  left: 63px;\r\n}\r\n\r\n.lds-roller div:nth-child(2) {\r\n  animation-delay: -0.072s;\r\n}\r\n\r\n.lds-roller div:nth-child(2):after {\r\n  top: 68px;\r\n  left: 56px;\r\n}\r\n\r\n.lds-roller div:nth-child(3) {\r\n  animation-delay: -0.108s;\r\n}\r\n\r\n.lds-roller div:nth-child(3):after {\r\n  top: 71px;\r\n  left: 48px;\r\n}\r\n\r\n.lds-roller div:nth-child(4) {\r\n  animation-delay: -0.144s;\r\n}\r\n\r\n.lds-roller div:nth-child(4):after {\r\n  top: 72px;\r\n  left: 40px;\r\n}\r\n\r\n.lds-roller div:nth-child(5) {\r\n  animation-delay: -0.18s;\r\n}\r\n\r\n.lds-roller div:nth-child(5):after {\r\n  top: 71px;\r\n  left: 32px;\r\n}\r\n\r\n.lds-roller div:nth-child(6) {\r\n  animation-delay: -0.216s;\r\n}\r\n\r\n.lds-roller div:nth-child(6):after {\r\n  top: 68px;\r\n  left: 24px;\r\n}\r\n\r\n.lds-roller div:nth-child(7) {\r\n  animation-delay: -0.252s;\r\n}\r\n\r\n.lds-roller div:nth-child(7):after {\r\n  top: 63px;\r\n  left: 17px;\r\n}\r\n\r\n.lds-roller div:nth-child(8) {\r\n  animation-delay: -0.288s;\r\n}\r\n\r\n.lds-roller div:nth-child(8):after {\r\n  top: 56px;\r\n  left: 12px;\r\n}\r\n\r\n@keyframes lds-roller {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.overlay {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.loader {\r\n  position: absolute;\r\n  padding: 0.75rem;\r\n  border-width: 1px;\r\n  border-color: #9ca3af;\r\n  width: 25%;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
